<template>
  <v-overlay color="white" opacity="1" @click="show = false">
    <div
      style="opacity: 1; visibility: visible; transition: all 2.5s ease"
      :style="page1"
    >
      <v-img src="@/assets/logo.png" width="60vw" class="mb-16"></v-img>
    </div>
    <div
      style="opacity: 0; visibility: none; transition: all 2.5s ease"
      :style="page2"
    >
      <div class="top-container">
        <div class="rounded-pill logo-container">
          <img src="@/assets/logo.png" class="logo-image" />
        </div>

        <div class="d-flex flex-column align-center mt-8">
          <div class="welcome-title mb-2">{{ $t("home.welcome") }}</div>

          <div class="welcome-subtitle">{{ $t("home.subtitle") }}</div>
        </div>
      </div>

      <div class="mid-container" v-if="!show">
        <div
          @click="$router.push('/islands')"
          class="button accent mb-2 text-right"
        >
          {{ $t("home.action") }}
        </div>
      </div>
      <div class="background-image-container" v-if="!show">
        <img
          src="@/assets/home_background.png"
          alt="homebg"
          class="background-image"
        />
      </div>
    </div>

    <img src="@/assets/waves.png" class="waves-image" :style="wavesAnimation" />
    <div
      class="espa-logo pt-4"
      style="transition: opacity 3s ease"
      :style="showEspa"
    >
      <img
        v-if="mobileLang.code == 'el'"
        src="@/assets/espa_el.jpg"
        style="width: 310px; height: 44.5px"
      />
      <img
        v-else
        src="@/assets/espa_en.jpg"
        style="width: 310px; height: 44.5px"
      />
    </div>
  </v-overlay>
</template>

<script>
import { mapState } from "vuex";

export default {
  created() {
    setTimeout(() => (this.show = false), 1000);
  },

  data() {
    return {
      show: true,
      dialog: true,
    };
  },

  computed: {
    ...mapState({
      mobileLang: (state) => state.base.mobileLang,
    }),
    wavesAnimation() {
      if (!this.show) {
        console.log;
        return "object-position: 63% 0;";
      } else return "";
    },

    showEspa() {
      if (this.show) {
        return "opacity: 0;";
      } else return "opacity: 1;";
    },

    page1() {
      if (this.show) {
        return "";
      } else return "opacity: 0;visibility: none";
    },

    page2() {
      if (this.show) {
        return "";
      } else return "opacity: 1;visibility: visible;";
    },
  },
};
</script>

<style scoped lang="scss">
.waves-image {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: 30% 0;
  margin-bottom: -80px;
  transition: object-position 2.5s ease;
}

.espa-logo {
  width: 100%;
  height: 105px;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
}

.background-image-container {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
}

.background-image {
  width: 100vw;
  height: 100vh;
  z-index: 1;
}

.top-container {
  width: 100vw;
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-container {
  width: 200px;
  background-color: white;
  padding: 5px 20px;
}
.logo-image {
  margin-top: 5px;
  width: 100%;
}

.welcome-title {
  font-size: 35px;
  font-weight: bold;
}

.welcome-subtitle {
  font-size: 24px;
  font-weight: regular;
}

.mid-container {
  position: fixed;
  top: 55%;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 999;
  width: 300px;
  display: flex;
  align-content: center;
  justify-content: center;
}

.button {
  font-size: 18px;
  border: 2px solid red;
  border-radius: 20px;
  padding: 5px 30px;
  white-space: nowrap;
}

@-webkit-keyframes waves {
  0% {
    object-position: 30% 0;

    // transform: scale(1);
  }

  100% {
    object-position: 63% 0;

    // transform: scale(1);
  }
}
</style>
